/* eslint-disable react/jsx-no-target-blank */
import * as React from 'react';
import cx from 'classnames';

import * as styles from './Link.css';

export interface ILinkProps extends React.HTMLProps<HTMLAnchorElement> {
  children: React.ReactNode;
  onClick?(event: React.SyntheticEvent): void;
  url: string;
  target?: string;
  title?: string;
  rel?: string;
  inline?: boolean;
}

export function Link(props: ILinkProps) {
  const { children, id, onClick, url, inline, target = 'self', title = '', rel } = props;

  return (
    <a
      target={`_${target}`}
      title={title}
      id={id}
      data-testid="Link"
      onClick={onClick}
      href={url}
      className={cx(styles['element'], inline && styles['element--inline'])}
      rel={rel}
    >
      {children}
    </a>
  );
}
